import $ from "jquery";

const sustainAbilityCounter = () => {
  const init = () => {
    suscounts();
  };
  const suscounts = () => {
    const el = {
      suscount: ".sus-count",
    };

    const susCountElements = $(el.suscount);

    susCountElements.each(function (index, element) {
      const targetValue = parseInt($(element).text());

      function animateValue(obj, start, end, duration) {
        const formattedStart = formatNumberWithLeadingZeroes(start);
        const formattedEnd = formatNumberWithLeadingZeroes(end);

        const digits = Array.from(formattedEnd, (digit, index) => {
          return `<span class="digit-${index}">${digit}</span>`;
        });

        $(element).html(digits.join(""));

        $({ value: formattedStart }).animate(
          { value: formattedEnd },
          {
            duration: duration,
            step: function (now) {
              const formattedValue = formatNumberWithLeadingZeroes(
                Math.floor(now)
              );
              digits.forEach((digit, index) => {
                $(element).find(`.digit-${index}`).text(formattedValue[index]);
              });
            },
          }
        );
      }

      animateValue(element, 0, targetValue, 16000);
    });
  };

  function formatNumberWithLeadingZeroes(number) {
    const numString = number.toString();
    const numberOfZeroes = 9 - numString.length;
    const leadingZeroes = "0".repeat(numberOfZeroes);
    return leadingZeroes + numString;
  }

  init();
};

try {
  sustainAbilityCounter();
} catch (error) {
  // eslint-disable-next-line no-console
  console.log(error);
}
